import { E as s, G as n, q as o } from "./export-cdcbfb2b.js";
import { d as i } from "./define-built-in-accessor-26bc7b69.js";
var a = n, c = i, l = s, u = o, e = l("species"), S = function(t) {
  var r = a(t);
  u && r && !r[e] && c(r, e, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
};
export {
  S as s
};
